<template>
  <div v-loading.fullscreen.lock="loading">
    <el-page-header @back="goBack" content="版本详情" style="font-size: 12px"></el-page-header>
    <div class="content_infos" style="margin-top: 20px">
      <div class="item_info">
        <div class="left_info">
          <div class="txt_name">版本号：</div>
          <div >{{info.verid}}</div>
        </div>
      </div>
      <div class="item_info">
        <div class="left_info">
          <div class="txt_name">状态：</div>
          <div class="tab_infos">{{info.verStatusName}}</div>
        </div>
        <div class="left_info">
          <div class="txt_name">发布时间：</div>
          <div>{{info.verTime}}</div>
        </div>
      </div>
      <div class="item_info">
        <div class="left_info">
          <div class="txt_name">标题：</div>
          <div>{{info.title}}</div>
        </div>
      </div>
      <div class="content_box" style="width: 1200px" v-html="info.content"></div>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: "editionInfo",
  data(){
    return{
      loading:false,
      info:{}
    }
  },
  mounted() {
    this.maneyInfdInfo()
  },
  methods:{
    async maneyInfdInfo() {
      this.loading = true;
      const {data: resData} = await this.$get("/sysver/info/"+this.$route.query.value);
      this.loading = false;
      if (resData.result != 200) return;
      this.info = resData.data;
    },
    goBack() {
      this.$router.back();
    },
  }
}
</script>

<style scoped lang="scss">
  .content_infos{
    font-size: 14px;
     .item_info{
       display: flex;
       margin-bottom: 20px;
       .left_info{
         display: flex;
         align-items: center;
         width: 240px;
         .txt_name{
           width: 80px;
           text-align: right;
         }
         .tab_infos{
           padding: 5px;
           background: #3a8ee6;
           color: #ffffff;
           border-radius: 4px;
         }
       }
     }
    .content_box{
      margin-left: 36px;
      img{
        max-width: 100% !important;
        height: auto !important;
      }
    }
  }
</style>